var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"layout-full_width"},[_c('h1',{staticClass:"title-error"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('errors.error')))+" 500 "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.symbol)}})]),_c('p',{staticClass:"error-mesage"},[_vm._v(_vm._s(_vm.$t('errors.please_retry')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }